<script setup>
import { defineProps, inject, computed } from 'vue';
import SubHead from '@/components/result/MLSRD-2026/SubHead.vue';
import SubArea from '@/components/result/MLSRD-2026/SubArea.vue';
import ScoreLevel from '@/components/result/MLSRD-2026/ScoreLevel.vue'; 

const pagetype ="literacy";
const region = "seoul";
const props = defineProps({
    schoolType: {
        type: String, 
        required: true
    }
});

// schoolData 주입
const schoolData = inject('schoolData');

// grades 정보 추출
const grades = computed(() => {
    if (schoolData.value && schoolData.value.classList && schoolData.value.classList.length > 0) {
        const gradeArray = [...new Set(schoolData.value.classList.map(item => item.grade_code))].filter(Boolean);
        return gradeArray;
    }
    return [];
});

</script>

<template lang="">
    <div class="slide-inner">
        <div class="content">    
            <SubHead :type="pagetype" :region="region" :hideTitleBox="true" />                  
            <SubArea :type="pagetype" :region="region" :isStudent="true" class="pb-5" />  
            <ScoreLevel :type="pagetype" :schoolType="props.schoolType" :grades="grades" />                  
        </div>
    </div>
</template>  

